import { render } from "./table-schedule-plane.vue?vue&type=template&id=06974a49&ts=true"
import script from "./table-schedule-plane.vue?vue&type=script&lang=ts"
export * from "./table-schedule-plane.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__